import React from 'react';
import { Link } from "react-router-dom";
import * as ROUTES from '../../constants/routes';
import styled from 'styled-components';
import * as MDICONS from '@material-ui/icons';
import FOLDER from '../../assets/svgs/folder.svg';

const ViewDashboardButton = styled.div`
    .btn {
        color: rgba(125, 46, 104, 1);
        border-color: rgba(125, 46, 104, 1);
        background-color: #fafafa;
        margin: 2px;

        &:hover {
            color: #fafafa;
            background-color: rgba(141, 51, 116, 1);
        }

        &:active {
            color: #fafafa;
            background-color: rgba(125, 46, 104, 1);
        }
    }
`;

const FolderCard = (card, index) => {
    return (
        <div className="col col-6 col-sm-4 col-md-3 col-lg-2" key={card.proid}>
            <div role="button" className="card" style={{ height: "55px", marginBottom: "10px", padding: "0px", backgroundColor: "rgba(125, 46, 104, 0.02)" }}>
                <div className="container d-flex h-100">
                    <div className="row justify-content-center align-self-center">
                        <div className="container d-flex justify-content-between">
                            <img src={FOLDER} alt={""} width="37px" className="px-2" />
                            <div className="py-1 px-2" style={{ fontWeight: "normal", fontSize: "14px", color: "rgba(0, 0, 0, 0.8)" }}>{card.projectTitle}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FolderCard;
